import React from 'react';

const OnPhoneComputer: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M93.852 97.103H110m-88.104 0H37.2m56.652 10.099h6.805c1.134 0 1.656.875 1.17 1.912l-7.183 9.277c-.81 1.054-1.566.804-2.52.804H38.926c-.955 0-1.423.179-1.963-.715l-7.723-9.366c-.486-1.037.036-1.912 1.17-1.912h6.805"
    ></path>
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M37.198 118.801V81.266c0-.947.774-1.698 1.71-1.698h53.215c.954 0 1.71.769 1.71 1.698v37.768"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M65.03 99.39h.99"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M66.38 7.788c11.684 0 21.171 9.42 21.171 21.02s-9.487 21.019-21.17 21.019c-11.684 0-21.171-9.42-21.171-21.02s9.47-21.02 21.17-21.02z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M40.835 42.677l-.504-1.447"
    ></path>
    <path
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M45.246 29.987l-10.982 3.682a1.794 1.794 0 00-1.134 2.288l4.753 13.977a1.813 1.813 0 002.304 1.126l14.384-4.826"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M37.199 83.947l-6.319 1.27c-3.618.66-6.84.017-9.29-2.574-2.465-2.592-3.6-7.418-2.16-10.671l11.522-29.563m70.983 54.694v-18c0-13.744-9.902-22.216-22.737-23.878L66.38 65.573l-7.885-7.864-17.282 5.416 4.986-9.902"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M77.488 72.115h5.581"
    ></path>
  </svg>
);

export default OnPhoneComputer;
